export default {
  Modal: {
    parts: ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'],
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
